module.exports = __webpack_public_path__ + "img/simbolo-branco.8bf71865.png";